<template>
  <b-card class="bg-white rounded-xl px-4 eventss">
    <el-drawer
      :title="`${this.action} FFC Podcast`"
      :visible.sync="drawer"
      :direction="direction"
      :before-close="handleClose"
    >
      <ValidationObserver
        tag="form"
        ref="obs1"
        @submit.prevent="addPodcastData()"
        class="bg-white h-100"
      >
        <div class="px-5 pt-4">
          <div class="">
            <label class="fsize16 text-dark font-semibold">Image</label><br>
            <div
            class="text-sm text-gray-600 font-medium px-2 py-1 mb-1 border rounded bg-gray-100 inline-block"
          >
            Recommended Size: 900 × 700px
          </div>
            <!-- <ValidationProvider
              name="Image"
              rules="required"
              v-slot="{ errors }"
            > -->
            <div>
              <FileUploader
                v-show="!image"
                :image="image"
                :onSuccess="handleSuccess"
                class="w-full my-1 m-auto display-none custmodal"
              />
              <!-- <span class="fsize12 text-danger">{{ errors[0] }}</span>
            </ValidationProvider> -->
              <div v-if="action != 'Edit'">
                <img
                  v-if="image"
                  :src="image"
                  ref="cover"
                  class="w-full my-1 m-auto display-none custmodal"
                />
                <div
                  class="flex justify-center text-red"
                  v-if="image"
                  @click="handleRemove"
                >
                  Remove image
                </div>
              </div>

              <div v-else>
                <img
                  v-if="image"
                  :src="
                    image.slice(0, 4) === 'data'
                      ? image
                      : `${$imageURL}/${image}`
                  "
                  ref="cover"
                  class="rounded-full widtht20percent m-auto display-none custmodal"
                />
                <div
                  class="text-center text-red"
                  v-if="image"
                  @click="handleRemove"
                >
                  Edit image
                </div>
              </div>
              <span
                v-if="imageErr"
                class="flex justify-center small text-danger"
                >{{ msg.image }}</span
              >
            </div>
            <p class="fsize12 text-danger" v-if="showValidationErr">
              {{ validationErr }}
            </p>
          </div>
          <div class="mt-4">
            <label class="fsize16 text-dark font-semibold">Title</label>
            <ValidationProvider
              name="Title"
              rules="required"
              v-slot="{ errors }"
            >
              <el-input
                placeholder="Please input"
                class="w-full"
                v-model="podcastTitle"
              ></el-input>
              <span class="fsize12 text-danger">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
          <div class="mt-4">
            <label class="fsize16 text-dark font-semibold"
              >Audio/Video URL</label
            >
            <ValidationProvider name="Url" rules="required" v-slot="{ errors }">
              <el-input
                placeholder="Please input"
                class="w-full"
                v-model="podcastUrl"
              ></el-input>
              <span class="fsize12 text-danger">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
          <div class="mt-5 flex justify-center">
            <base-button
              outline
              @click="action == 'Add' ? addPodcastData() : editPodcastData()"
              class="px-8 fsize14 py-2 mx-1"
              type="primary"
            >
              Submit
            </base-button>
          </div>
        </div>
      </ValidationObserver>
    </el-drawer>

    <div class="flex justify-between items-center">
      <div>
        <h2 class="text-2xl font-semibold">FFC Podcast</h2>
      </div>
      <base-button
        outline
        class="px-6 py-1 mx-1"
        type="primary"
        @click="actionPerform('', 'Add')"
      >
        <span class="btn-inner--text flex justify-between items-center"
          ><feather-icon icon="PlusIcon" class="cust-HW"></feather-icon> Add
          Podcast
        </span>
      </base-button>
    </div>
    <div class="mt-5">
      <b-input-group class="">
        <b-form-input
          class="border-none shadow-lg"
          type="text"
          min="0.00"
          v-model="search"
          placeholder="Enter Search...."
          v-on:input="searchBy"
        ></b-form-input>

        <b-input-group-append>
          <b-button
            variant="white"
            class="flex items-center shadow-lg"
            aria-label="search"
          >
            <feather-icon
              class="cursor-pointer mr-2"
              icon="SearchIcon"
              svgClasses="w-4 h-4"
            ></feather-icon>
          </b-button>
        </b-input-group-append>
      </b-input-group>
      <el-table
        class="table-responsive table-flush mt-6"
        header-row-class-name="thead-light table-th-color"
        :data="tableData"
        border
      >
        <el-table-column
          label="Image"
          min-width="250px"
          prop="heading"
          class="ml-12"
          sortable
        >
          <template v-slot="{ row }">
            <img
              v-if="row.hasOwnProperty('bannerImage') && row.bannerImage != ''"
              :src="`${$imageURL}/${row.bannerImage}`"
              :alt="image"
            />
            <img
              v-else
              :src="`${$imageURL}/caregiversaathi/default/dummy%20image.jpg`"
              :alt="image"
            />
          </template>
        </el-table-column>
        <el-table-column
          label="Title"
          min-width="250px"
          prop="heading"
          class="ml-12"
          sortable
        >
          <template v-slot="{ row }">
            <p class="fsize14 text-dark">{{ row.title }}</p>
          </template>
        </el-table-column>
        <el-table-column
          label="Created Date"
          min-width="250px"
          prop="heading"
          class="ml-12"
          sortable
        >
          <template v-slot="{ row }">
            <p class="font-semibold text-left name mb-0 text-sm">
              {{ getDate(row.createdAt) }}
            </p>
          </template>
        </el-table-column>
        <el-table-column
          label="Audio/Video URL"
          min-width="250px"
          prop="description"
          class="ml-12"
          sortable
        >
          <template v-slot="{ row }">
            <p class="fsize14 text-dark">{{ row.url }}</p>
          </template>
        </el-table-column>

        <el-table-column
          label="Actions"
          min-width="100px"
          class-name="text-center"
        >
          <template v-slot="{ row }">
            <div class="flex justify-center items-center gap-1">
              <feather-icon
                @click="actionPerform(row, 'Edit')"
                icon="EditIcon"
                svgClasses="w-4 h-4 text-blue-500 cursor-pointer"
              ></feather-icon>
              <feather-icon
                @click="deletePodcastData(row)"
                icon="Trash2Icon"
                svgClasses="w-4 h-4 text-red-600 cursor-pointer"
              ></feather-icon>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="mt-5 flex justify-end">
      <el-pagination
        @current-change="
          (value) => {
            currentPage = value;
            getffcPodcastData();
          }
        "
        layout="prev,pager,next"
        :per-size="10"
        :total="pageCount"
      >
      </el-pagination>
    </div>
  </b-card>
</template>

<script>
import FileUploader from "@/components/FileUploader";
import moment from "moment";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { extend } from "vee-validate";
import * as rules from "vee-validate/dist/rules";
extend("required", {
  ...rules.required,
  message: "This field is required",
});
extend("integer", {
  ...rules.integer,
  message: "This field must be an integer",
});
export default {
  data() {
    return {
      drawer: false,
      direction: "rtl",

      search: "",
      tableData: [],

      // add/edit initiative
      action: "",
      selectedId: "",
      selectedItem: "",
      podcastTitle: "",
      podcastUrl: "",

      // pagination
      currentPage: 1,
      pageCount: 0,

      // image
      showValidationErr: false,
      validationErr: "This field is required",
      image: null,
      coverImage: null,
      imageErr: false,
      msg: {
        image: "",
      },
    };
  },
  methods: {
    searchBy: _.debounce(function (e) {
      this.getffcPodcastData();
    }, 500),

    getDate(date) {
      return moment(date).format("MMMM Do YYYY, h:mm a");
    },
    async getffcPodcastData() {
      let offset = 0;
      let payload = {
        pagination: true,
      };

      if (this.currentPage == 1) {
        Object.assign(payload, { offset: offset });
      } else {
        offset = 10 * this.currentPage - 10;
        Object.assign(payload, { offset: offset });
      }
      if (this.search != "") {
        Object.assign(payload, { search: this.search });
      }
      let result = await this.$store.dispatch("ffc/getPodcast", payload);
      console.log(result, "RESULT");
      this.tableData = result.data.data;
      this.pageCount = result.data.count;
    },
    clearAll() {
      this.action = "";
      this.selectedId = "";
      this.podcastUrl = "";
      this.podcastTitle = "";

      this.image = "";
      this.coverImage = "";
    },
    handleClose() {
      this.drawer = false;
      this.clearAll();
    },
    actionPerform(VALUE, ACTION) {
      if (ACTION == "Add") {
        this.drawer = true;
        this.action = ACTION;
      } else if (ACTION == "Edit") {
        this.drawer = true;
        this.action = ACTION;
        this.selectedItem = VALUE;
        this.selectedId = VALUE._id;

        this.podcastTitle = VALUE.hasOwnProperty("title") ? VALUE.title : "";
        this.podcastUrl = VALUE.hasOwnProperty("url") ? VALUE.url : "";
        this.image = VALUE.hasOwnProperty("bannerImage")
          ? VALUE.bannerImage
          : "";
      }
    },
    async addPodcastData() {
      if (this.image == "" || this.image == null) {
        this.showValidationErr = true;
      } else {
        this.showValidationErr = false;
      }
      this.$refs.obs1.validate().then(async (success) => {
        if (success) {
          if (this.image != "" && this.coverImage != "") {
            const payload = new FormData();
            payload.append("title", this.podcastTitle);
            payload.append("url", this.podcastUrl);
            payload.append("bannerImage", this.coverImage);
            let result = await this.$store.dispatch("ffc/addPodcast", payload);
            this.coverImage = "";
            this.image = "";
          } else {
            let payload = {};
            if (this.podcastTitle != "") {
              Object.assign(payload, { title: this.podcastTitle });
            }

            if (this.podcastUrl != "") {
              Object.assign(payload, { url: this.podcastUrl });
            }

            let result = await this.$store.dispatch("ffc/addPodcast", payload);
          }
          await this.clearAll();
          await this.handleClose();
          await this.getffcPodcastData();
        }
      });
    },
    async editPodcastData() {
      const payload = new FormData();
      payload.append("_id", this.selectedId);
      if (
        this.selectedItem.hasOwnProperty("title") &&
        this.podcastTitle != this.selectedItem.title
      ) {
        payload.append("title", this.podcastTitle);
      }

      if (
        this.selectedItem.hasOwnProperty("url") &&
        this.podcastUrl != this.selectedItem.url
      ) {
        payload.append("url", this.podcastUrl);
      }

      if (
        this.selectedItem.hasOwnProperty("bannerImage") &&
        this.image != this.selectedItem.bannerImage
      ) {
        payload.append("bannerImage", this.coverImage);
      }

      let result = await this.$store.dispatch("ffc/editPodcast", payload);
      await this.clearAll();
      await this.handleClose();
      await this.getffcPodcastData();
    },
    async deletePodcastData(ITEM) {
      let result = await this.$store.dispatch("ffc/deletePodcast", {
        _id: ITEM._id,
        isDeleted: true,
      });
      await this.getffcPodcastData();
    },
    handleSuccess(image) {
      console.log(image, "UPLOADED FIEL");

      // let mByte = 5 * 1048576;
      // if (image.size > mByte) {
      //   this.$swal.fire({
      //     title: "File size exceeds the allowed limit!",
      //     // text: "Please ensure that the file size does not exceed 5MB",
      //     html: "<p style='text-align:center'>Please ensure that the file size does not exceed 5MB</p>",
      //     confirmButtonText: "Okay",
      //     icon: "warning",
      //     confirmButtonColor: "#830c81",
      //     showCancelButton: false,
      //   });
      //   return;
      // }
      this.imageErr = false;
      if (this.fileTypeSelected == "Image" && !image.type.includes("image")) {
        this.imageErr = true;
        this.msg.image = "Upload Image Only";
      }
      // else if (
      //   this.fileTypeSelected == "Video" &&
      //   !image.type.includes("video")
      // ) {
      //   this.imageErr = true;
      //   this.msg.image = "Upload Video Only";
      // } else if (
      //   this.fileTypeSelected == "Document" &&
      //   !image.type.includes("pdf")
      // ) {
      //   this.imageErr = true;
      //   this.msg.image = "Upload PDF Only";
      // }
      else {
        this.imageErr = false;
        this.coverImage = image;
        this.readerData(image);
      }
    },
    readerData(rawFile) {
      let loader = this.$loading();
      const reader = new FileReader();
      reader.onload = (e) => {
        this.$emit("load", (this.image = e.target.result));
        loader.close();
      };
      reader.readAsDataURL(rawFile);
    },
    handleRemove() {
      this.image = null;
      this.coverImage = null;
    },
  },
  async mounted() {
    await this.getffcPodcastData();
  },
  components: {
    FileUploader,
    ValidationObserver,
    ValidationProvider,
    rules,
    extend,
  },
  watch: {
    drawer(value) {
      if (value == false) {
        this.$refs["obs1"].reset();
        this.$refs["obs1"].resetValidation();
      }
    },
    image(value) {
      if (value != "" && value != null) {
        this.showValidationErr = false;
      }
    },
  },
};
</script>
